import { render, staticRenderFns } from "./addMicroType.vue?vue&type=template&id=22f8e4bc&scoped=true&"
import script from "./addMicroType.vue?vue&type=script&lang=js&"
export * from "./addMicroType.vue?vue&type=script&lang=js&"
import style0 from "./addMicroType.vue?vue&type=style&index=0&id=22f8e4bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f8e4bc",
  null
  
)

export default component.exports